import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { dotSpinner } from "ldrs";
import { useTheme } from "@mui/material/styles";

const DotSpinner = ({ color = "default" }) => {
  const theme = useTheme();

  useEffect(() => {
    dotSpinner.register();
  }, []);

  // Mapeo para obtener los colores del tema
  const colorMap = {
    inherit: "inherit",
    default: theme.palette.text.primary,
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    error: theme.palette.error.main,
    info: theme.palette.info.main,
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        zIndex: 9999,
      }}
    >
      <l-dot-spinner
        size="40"
        speed="0.9"
        color={colorMap[color]} // Usar el color del tema
      ></l-dot-spinner>
    </div>
  );
};

// Añadir validación de props
DotSpinner.propTypes = {
  color: PropTypes.oneOf([
    "inherit",
    "default",
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
};

export default DotSpinner;
